export const APP_SERVICE_NAME = process.env.VUE_APP_SERVICE_NAME;
export const APP_SERVICE_NAME_KANA = process.env.VUE_APP_SERVICE_NAME_KANA;
export const APP_URL_SCHEME_NAME = process.env.VUE_APP_URL_SCHEME_NAME;
export const APP_SUPPORTED_URL_SCHEMES =
  process.env.VUE_APP_SUPPORTED_URL_SCHEMES;
export const APP_GOOGLE_MAP_API_KEY = process.env.VUE_APP_GOOGLE_MAP_API_KEY;
export const APP_API_URL_BASE = process.env.VUE_APP_API_URL_BASE;
export const APP_URL_CANCEL_RATE = process.env.VUE_APP_URL_CANCEL_RATE;
export const APP_START_URL = process.env.VUE_APP_START_URL;
export const APP_URL_FAQ = process.env.VUE_APP_URL_FAQ;
export const APP_URL_ANONYMOUS_FEEDBACK_FORM =
  process.env.VUE_APP_URL_ANONYMOUS_FEEDBACK_FORM;
export const APP_URL_REPORT_JOB_CHANGE =
  process.env.VUE_APP_URL_REPORT_JOB_CHANGE;
